/**
 * Mooore Please V6.1: Kaching / third-party AJAX add -> existing Shopify cart drawer.
 *
 * Does NOT submit forms, write to the cart or alter bundle quantities, prices or selling plans.
 * Detects successful /cart/add(.js) AJAX responses, then emits the theme's
 * documented CartLinesUpdateEvent so the stock cart components refresh and auto-open.
 * Isolated to the V6.1 draft and optional in the theme editor.
 */
(() => {
  if (window.__mpV6KachingDrawerBridgeInstalled) return;
  if (!document.querySelector('.mpv4[data-mpv6-app-native="true"]')) return;
  window.__mpV6KachingDrawerBridgeInstalled = true;

  const nativeFetch = window.fetch.bind(window);
  let pendingTimer = 0;
  let lastNativeAddAt = 0;
  let lastEventFromBridge = false;

  document.addEventListener('shopify:cart:lines-update', (event) => {
    if (event.action === 'add' && !lastEventFromBridge) lastNativeAddAt = Date.now();
  });

  function isCartAdd(input, init) {
    const url = typeof input === 'string' ? input
      : input && typeof input.url === 'string' ? input.url
      : String(input || '');
    const method = String(init?.method || input?.method || 'GET').toUpperCase();
    if (method !== 'POST') return false;
    try {
      const parsed = new URL(url, location.href);
      return parsed.origin === location.origin &&
        /\/cart\/add(?:\.js)?\/?$/.test(parsed.pathname);
    } catch (_) {
      return false;
    }
  }

  function scheduleDrawerRefresh() {
    clearTimeout(pendingTimer);
    // Apps can issue several sequential add requests for a single bundle.
    // Settle after the last response, rather than briefly showing a partial bundle.
    pendingTimer = window.setTimeout(async () => {
      if (document.visibilityState === 'hidden') return;
      if (Date.now() - lastNativeAddAt < 1200) return; // app/theme already emitted an add event
      if (!document.querySelector('theme-drawer#cart-drawer cart-drawer-component')) return;
      try {
        const cartResponse = await nativeFetch((window.Shopify?.routes?.root || '/') + 'cart.js', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });
        if (!cartResponse.ok) return;
        const cart = await cartResponse.json();
        if (!cart?.item_count) return;
        const { CartLinesUpdateEvent } = await import('@shopify/events');
        const promise = Promise.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: {
            items: cart.items,
            itemCount: cart.item_count,
            source: 'mp-v6-kaching-drawer-bridge',
            didError: false,
          },
        });
        // The native cart drawer and cart-items-component listen to this same event;
        // they refresh their own section, update the icon and auto-open.
        const form = document.querySelector('.mpv4[data-mpv6-app-native="true"] .mpv4-product-form');
        const lines = (cart.items || []).map((item) => ({
          merchandiseId: String(item.variant_id),
          quantity: Number(item.quantity) || 1,
        }));
        lastEventFromBridge = true;
        (form || document).dispatchEvent(new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines,
          promise,
        }));
        lastEventFromBridge = false;
      } catch (error) {
        lastEventFromBridge = false;
        console.warn('[Mooore V6] Cart drawer update unavailable:', error);
      }
    }, 450);
  }

  const previousFetch = window.fetch;
  window.fetch = function (...args) {
    const matches = isCartAdd(args[0], args[1]);
    const responsePromise = previousFetch.apply(this, args);
    if (matches && responsePromise?.then) {
      responsePromise.then((response) => {
        if (response?.ok) scheduleDrawerRefresh();
      }).catch(() => {});
    }
    return responsePromise;
  };

  // Some Shopify apps still use XMLHttpRequest rather than fetch.
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this.__mpV6CartAddRequest = isCartAdd(url, { method });
    return originalOpen.call(this, method, url, ...rest);
  };
  XMLHttpRequest.prototype.send = function(...args) {
    if (this.__mpV6CartAddRequest) {
      this.addEventListener('load', () => {
        if (this.status >= 200 && this.status < 300) scheduleDrawerRefresh();
      }, { once: true });
    }
    return originalSend.apply(this, args);
  };
})();